module.exports = __webpack_public_path__ + "static/img/stop-msg-icon.54ffca2c.png";